export default "__VITE_ASSET__d876e9ca__"